import React, { useEffect, useRef , useState} from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { FaUsers, FaRegEdit } from "react-icons/fa";
import TableSale from "./TableSale";
import TableReturn from "./TableReturn";
import TablePayment from "./TablePayment";
import TableQuotation from "./TableQuotation";
import PaymentViewModal from "./pharmacymodels/PaymentViewModal";
import AddPatientModal from "./AddPatientModal";
function PharmacySaleView({ show, onClose, invoice, closePopover }) {
  const canvasRef = useRef(null);
  const [activeTab, setActiveTab] = useState("sales(1)");
  const [showSimplePaymentModal, setShowSimplePaymentModal] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  useEffect(() => {
    if (show && closePopover) {
      closePopover();
    }
  }, [show, closePopover]);

  if (!invoice) return null;

  const getInitials = (name) =>
    name ? name.charAt(0).toUpperCase() : "U";

  return (
    <Offcanvas
      ref={canvasRef}
      show={show}
      onHide={onClose}
      placement="end"
      className="!w-[70%]"  
    >
      {/* HEADER */}
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="flex items-center gap-3">
            Sales Details
        </Offcanvas.Title>
      </Offcanvas.Header>

     
      <Offcanvas.Body className="px-3 py-1">

        {/* STATS */}
<div className="w-full bg-white border border-gray-200 rounded-xl p-6 flex items-start justify-between mb-4">

  <div className="flex gap-6 items-start">

 
    <div className="w-20 h-20 rounded-xl bg-blue-100 flex items-center justify-center text-3xl font-bold text-blue-700">
      {getInitials(invoice.customerName)}
    </div>
    <div>
      <h3 className="text-2xl font-semibold text-gray-900">
        {invoice.customerName}
      </h3>

      <p className="text-gray-500 text-sm mt-1">
        Customer • {invoice.gender || "Male"} ({invoice.age || "35"}y)
      </p>

      <div className="grid grid-cols-2 gap-x-10 gap-y-1 text-sm mt-4">
        <p><b>First Sale:</b> {invoice.txnDate}</p>
        <p><b>Contact:</b> {invoice.phoneNumber}</p>
        <p><b>Address:</b> Sector 37, Gurgaon, Haryana</p>
      </div>

      <div className="flex gap-3 mt-1">
        <div
    className=" inline-flex items-center gap-2 text-green-600 hover:text-green-700 cursor-pointer transition-all border-t border-gray-100 pt-3"
         onClick={() => setShowAdd(true)} >
         <FaRegEdit className="text-base" />
             <span className="font-medium text-[15px]">Edit</span>
        </div>
      </div>
    </div>
  </div>
  <button className="gradient-button px-6 py-2 rounded-lg text-white shadow-md whitespace-nowrap"
    onClick={() => setShowSimplePaymentModal(true)}>
    + Add Payment
  </button>
<PaymentViewModal
  show={showSimplePaymentModal}
  onHide={() => setShowSimplePaymentModal(false)}
customerName={invoice.customerName}
/>

</div>


{/* STATS LINE WITH BORDER TOP + BOTTOM */}
<div className="grid grid-cols-8 gap-4 px-6 py-4 border-b border-gray-200 bg-white text-center">

  <div>
    <p className="text-gray-500 text-xs uppercase font-medium">TOTAL SALES</p>
    <p className="font-bold text-gray-800">₹498.00</p>
  </div>

  <div>
    <p className="text-gray-500 text-xs uppercase font-medium">SALES DUE</p>
    <p className="font-bold text-green-600">₹359.00</p>
  </div>

  <div>
    <p className="text-gray-500 text-xs uppercase font-medium">TOTAL RETURNS</p>
    <p className="font-bold text-gray-800">₹718.00</p>
  </div>

  <div>
    <p className="text-gray-500 text-xs uppercase font-medium">RETURNS DUE</p>
    <p className="font-bold text-red-600">₹359.00</p>
  </div>

  <div>
    <p className="text-gray-500 text-xs uppercase text-[10px] font-medium">BALANCE</p>
    <p className="font-bold text-gray-700">-</p>
  </div>

  <div>
    <p className="text-gray-500 text-xs uppercase font-medium">IMPORTANCE</p>
    <p className="font-bold text-gray-700">-</p>
  </div>

  <div>
    <p className="text-gray-500 text-xs uppercase font-medium">REVISITS</p>
    <p className="font-bold text-gray-700">-</p>
  </div>

  <div>
    <p className="text-gray-500 text-xs uppercase font-medium">AVG ORD VALUE</p>
    <p className="font-bold text-gray-900">₹249.00</p>
  </div>
</div>

        {/* TABS */}
          <div className="tabs-container">
                      <div className="tabs-header">
                        {[
                          "Sales(1)",
                          "Returns",
                          "Payments",
                          // "Quotation",
                        ].map((t) => (
                          <button
                            key={t}
                            className={`tab-button ${t.toLowerCase() === activeTab ? "active" : ""}`}
                            onClick={() => setActiveTab(t.toLowerCase())}
                          >
                            {t}
                          </button>
                        ))}
                      </div>
        
                      <div className="tab-content">
                        {activeTab === "sales(1)" && <TableSale />}
                        {activeTab === "returns" && <TableReturn />}
                        {activeTab === "payments" && <TablePayment />}
                        {/* {activeTab === "quotation" && <TableQuotation />} */}
                      </div>
                    </div>

      </Offcanvas.Body>
      <style>
        {`
        .tabs-container {
          margin: 18px 22px 22px 22px;
          background: #fff;
          border-radius:8px;
          overflow:hidden;
          box-shadow: 0 1px 6px rgba(0,0,0,0.03);
        }
        .tabs-header {
          display:flex; border-bottom:1px solid #eee; background:#fff;
        }
        .tab-button {
          padding: 14px 18px;
          background:none; border:none; cursor:pointer; font-weight:600; color:#666; font-size:13px;
        }
        .tab-button.active {
          color:#2e6b4a; border-bottom:3px solid #7ee6a0ff; background: linear-gradient(180deg, rgba(78,155,108,0.06), transparent);
        }
        .tab-content { padding: 12px; min-height: 260px; }
        `}
      </style>
     <AddPatientModal
  open={showAdd}
  onClose={() => setShowAdd(false)}
  onSave={(newPatient) => {}}
  isEdit={true}   
/>


    </Offcanvas>
  );
}

export default PharmacySaleView;
